import { Businesses, Routes } from "@just-in-types";

export const emptyRoutes: Routes.CleanRoutesObject = {
  covidquestions: {
    alwaysShow: false,
    enabled: false,
    optional: false,
  },
  customertype: {
    alwaysShow: false,
    enabled: false,
    optional: false,
  },
  dateofbirth: {
    alwaysShow: false,
    enabled: false,
    optional: false,
  },
  email: {
    alwaysShow: false,
    enabled: false,
    optional: false,
  },
  language: {
    alwaysShow: false,
    enabled: false,
    optional: false,
  },
  name: {
    alwaysShow: false,
    enabled: false,
    optional: false,
  },
  optin: {
    alwaysShow: false,
    enabled: false,
    optional: false,
  },
  signature: {
    alwaysShow: false,
    enabled: false,
    optional: false,
    takeMugshot: false,
    waiverText: "",
  },
  supercard: { alwaysShow: false, enabled: false, optional: false },
  thanks: {
    timeout: 10000,
  },
  vehicles: {
    alwaysShow: false,
    enabled: false,
    optional: false,
  },
  zip: {
    alwaysShow: false,
    enabled: false,
    optional: false,
  },
};

export const emptySite: Businesses.EmptySite = {
  accessDashboardSize: null,
  accessDashboardSizeM: null,
  accessDashboardText: null,
  accessDashboardTextSpanish: null,
  accessDashboardType: null,
  allowOptOut: false,
  descSize: null,
  descSizeM: null,
  descText: null,
  descTextSecondline: null,
  descTextSpanish: null,
  descTextSpanishSecondline: null,
  descType: null,
  // descTypeM: null,
  enableExpanolBtn:false,
  enableItalic:false,
  enableRowInTxtMsg:false,
  enableVipClub:false,
  englishKeyword:null,
  englishLocation:null,
  englishVipClubCheckboxText:null,
  englishVipClubHoverText:null,
  guid: null,
  heightForDesktop: null,
  heightForMobile: null,
  helpMenu: null,
  helpMenus: null,
  homeBtnEnable: false,
  homeBtnUrl: null,
  homeButtonBgColor: null,
  homeButtonColor: null,
  homeButtonText: null,
  homeButtonTextSpanish: null,
  howitworksBgColor: null,
  howitworksColor: null,
  howitworksText: null,
  howitworksTexts: null,
  kioskName: null,
  kioskNameEs: null,
  noCheckIn: false,
  path: null,
  retToPageSize: null,
  retToPageSizeM: null,
  retToPageText: null,
  retToPageTextSpanish: null,
  retToPageType: '',
  routes: emptyRoutes,
  showCoupons: false,
  siteId: null,
  siteName: null,
  smartMatching: false,
  spanishKeyword: null,
  spanishLocation: null,
  spanishVipClubCheckboxText: null,
  spanishVipClubHoverText: null,
  theme: null,
  titleSize: null,
  titleSizeM: null,
  titleText: null,
  titleTextSpanish: null,
  titleType: null,
  tncSize: null,
  tncSizeM: null,
  tncText: null,
  tncTextSpanish: null,
  tncType: null,
  widthForDesktop: null,
  widthForMobile: null,
  // titleTypeM: null,
  // titleText: null,
};

export const emptySiteOptions: Businesses.EmptySiteOptions = {
  accessDashboardSize: '',
  accessDashboardSizeM: '',
  accessDashboardText: '',
  accessDashboardTextSpanish: '',
  accessDashboardType: '',
  allowOptOut: false,
  descSize: "",
  descSizeM: "",
  descText: "",
  descTextSecondline: "",
  descTextSpanish: "",
  descTextSpanishSecondline: "",
  descType: "",
  // descTypeM: "",
  disableKeyboard: false,
  enableExpanolBtn:false,
  enableItalic:false,
  enableRowInTxtMsg:false,
  enableVipClub:false,
  englishKeyword:"",
  englishLocation:"",
  englishVipClubCheckboxText:"",
  englishVipClubHoverText:"",
  guid: "",
  heightForDesktop: "",
  heightForMobile: "",
  helpMenu: "",
  helpMenus: "",
  homeBtnEnable: false,
  homeBtnUrl: "",
  homeButtonBgColor: "",
  homeButtonColor: "",
  homeButtonText: "",
  homeButtonTextSpanish: "",
  howitworksBgColor: "",
  howitworksColor: "",
  howitworksText: "",
  howitworksTexts: "",
  kioskName: "",
  kioskNameEs: null,
  noCheckIn: false,
  retToPageSize: '',
  retToPageSizeM: '',
  retToPageText: '',
  retToPageTextSpanish: '',
  retToPageType: '',
  s3Id: null,
  shortcode: null,
  showCoupons: false,
  siteName: "",
  smartMatching: false,
  spanishKeyword: "",
  spanishLocation: "",
  spanishVipClubCheckboxText: "",
  spanishVipClubHoverText: "",
  titleSize: "",
  titleSizeM: "",
  titleText: "",
  titleTextSpanish: "",
  titleType: "",
  tncSize: "",
  tncSizeM: "",
  tncText: "",
  tncTextSpanish: "",
  tncType: "",
  // titleTypeM: "",
  // titleText: "",
  urgId: null,
  widthForDesktop: "",
  widthForMobile: "",
};
// const cleanRoute = (possible?: PossibleRoute): Routes.Route => {
//   const route: Routes.Route = {
//     alwaysShow: false,
//     enabled: false,
//     optional: false,
//   };

//   if (possible) {
//     if (possible.alwaysShow && typeof possible.alwaysShow === 'boolean') {
//       route.alwaysShow = possible.alwaysShow;
//     }
//     if (possible.alwaysShow && typeof possible.alwaysShow === 'boolean') {
//       route.alwaysShow = possible.alwaysShow;
//     }
//     if (possible.alwaysShow && typeof possible.alwaysShow === 'boolean') {
//       route.alwaysShow = possible.alwaysShow;
//     }
//   }

//   return route;
// };

// const cleanSignatureRoute = (
//   possible?: PossibleSignatureRoute,
// ): Routes.SignatureRoute => {
//   const route = cleanRoute(possible);
//   const signatureRoute: Routes.SignatureRoute = {
//     ...route,
//     takeMugshot: false,
//     waiverText: 'placeholder',
//   };

//   if (possible) {
//     if (possible.takeMugshot && typeof possible.takeMugshot === 'boolean') {
//       signatureRoute.takeMugshot = possible.takeMugshot;
//     }
//     if (possible.waiverText && typeof possible.waiverText === 'string') {
//       signatureRoute.waiverText = possible.waiverText;
//     }
//   }

//   return signatureRoute;
// };

// const cleanRoutes = (possible?: PossibleRoutes): Routes.RoutesObject => {
//   const routes = emptyRoutes;

//   if (possible) {
//     routes.email = cleanRoute(possible.email);
//     routes.language = cleanRoute(possible.language);
//     routes.name = cleanRoute(possible.name);
//     routes.signature = cleanSignatureRoute(possible.signature);
//     routes.vehicles = cleanRoute(possible.vehicles);
//     routes.zip = cleanRoute(possible.zip);
//   }

//   return routes;
// };

// const cleanSite = (possible?: PossibleSite): Businesses.Site => {
//   const site = emptySite as Businesses.Site | Businesses.EmptySite

//   if (possible) {
//     if (typeof possible.allowOptOut === 'boolean') {
//       site.allowOptOut = possible.allowOptOut;
//     }
//     if (possible.guid) {
//       site.guid = possible.guid
//     }
//     if (possible.kioskName) {
//       site.kioskName = possible.kioskName
//     } else {
//       throw new Error('')
//     }

//   } else {
//     throw new Error('no site found!')
//   }

//   return site;
// }

export default () => null;



// WEBPACK FOOTER //
// ./src/adminFunctions/cleanSites.ts